const en = {
    message: {
        loingEnterPhone: "Enter your phone number"
    }

}

export default en;